import { Work } from "../common/types";
import { DigitalColor, InkOnPaper, PencilOnPapel, WhiteCharcoal } from "./techniques";

// Because we hate paying for databases

export const CloseTheThirdEye: Work = {
    title: {
        "es": "Cierra el tercer ojo",
        "en": "Close the third eye",
        "ja": "三つ目の目を閉じて"
    },
    technique: PencilOnPapel,
    year: 2025,
    imageUrl: "/img/art/third_eye.jpg",
    previewUrl: "/img/art/third_eye_low.jpg",

    description: {
        "en": "This is both a reference to the fact that the artist needs to draw objects how they really look like, instead of the image he has in his mind. But it also resonates with how we often ignore the facts and only look from our believes leading to a biased look of the world.",
        "es": "Esta es una referencia tanto de como él artista necesita dibujar los objetos como realmente se ven y no como la imagen que el tiene en su mente. Pero también rima con el hecho de que seguido ignoramos los hechos y vemos solo desde nuestras creencias, lo que termina en una vista sesgada del mundo.",
    },
        
    link: "/projects/project1",
    isBuyable: false,
    price: "1000 MXN",
    dimensions: [30, 30]
};
export const StillRememberYou: Work = {
    title: {
        "es": "Aún te recuerdo",
        "en": "I still remember you",
        "ja": "君をまだ覚えている"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/still_remember.jpg",
    previewUrl: "/img/art/still_remember_low.jpg",

    description: {
        "en": "In honour of my late dog, drawn during Day of the Dead",
        "es": "En honor de mi perro fallecido, que en paz descanse. Dibujado durante el Día de los muertos",
        "ja": "亡くなった犬に。死者の日に描きました"
    },
    isBuyable: false,
    sold: true,
    price: "600 MXN",        
    link: "/projects/project1",
    dimensions: [13, 21]
};

export const Rite: Work = {
    title: {
        "es": "Rito",
        "en": "Rite",
        "ja": "Rite" //TODO: Proper translation
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/rito.jpg",
    previewUrl: "/img/art/rito_low.jpg",

    description: {
        "en": ""
    },
        
    isBuyable: false,
    price: "600 MXN",
    link: "/projects/project1",
    dimensions: [20, 18]
};


export const EmergentCia: Work = {
    title: {
        en: 'Emergent.cia',
        es: 'Emergent.cia',
    },
    description: {
        en: 'This drawing showcases the beginning of an artist voyage, lifting their art from the anonymity.',
        es: 'Este dibujo capta el inicio del viaje de un artista, levantando su arte desde el anonimato.',
    },
    technique: WhiteCharcoal,
    year: 2026,
    imageUrl: '/img/art/emergentcia_low.jpg',
    isBuyable: false,
    price: '1000 MXN',
    sold:true,
    dimensions: [50, 36]
}

//#region INKTOBER SAMO 2025

export const Coffee: Work =  {
    title: {
        "es": "Café",
        "en": "Coffee",
        "ja": "コーヒー"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/coffee.jpg",

    description: {
        "en": ""
    },
        
    isBuyable: false,
    price: "500 MXN",
    link: "/projects/project1",
    dimensions: [22, 30]
};

export const InvitingPumpkin: Work =  {
    title: {
        "es": "Calabaza",
        "en": "Pumpkin",
        "ja": "カボチャ"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/pumpkin.jpg",

    description: {
        "en": ""
    },
        
    isBuyable: false,
    price: "600 MXN",
    link: "/projects/project1",
    dimensions: [30, 22]
};

export const Lunaccino: Work = {
    title: {
        "es": "Lunaccino",
        "en": "Lunaccino",
        "ja": "Lunaccino"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/lunaccino.jpg",
    previewUrl: "/img/art/lunaccino_low.jpg",

    description: {
        "en": ""
    },
        
    isBuyable: false,
    price: "400 MXN",
    link: "/projects/project1",
    dimensions: [22, 18]
};


export const Magia: Work = {
    title: {
        "es": "Magia",
        "en": "Magic",
        "ja": "魔法"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/magic.jpg",

    description: {
        "en": ""
    },
        
    isBuyable: false,
    link: "/projects/project1",
    dimensions: [11, 11]
};

export const CatInCustoms: Work = {
    title: {
        "es": "Gata en aduana (ft. Nikita)",
        "en": "Cat in customs (ft. Nikita)",
        "ja": "税関 の猫"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/catcustoms.jpg",

    description: {
        "en": "In memory of the artwork stuck in customs by Fer Ricardez, my brother",
        "es": "En memoria de la pintura atrapada en aduana de Fer Ricardez, mi hermano"
    },
        
    isBuyable: false,
    link: "/projects/project1",
    dimensions: [11, 11]
};

export const Candle: Work = {
    title: {
        "es": "Vela",
        "en": "Candle",
        "ja": "蝋燭"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/candle.jpg",

    description: {
        "en": "",
    },
        
    isBuyable: false,
    price: "500 MXN",
    link: "/projects/project1",
    dimensions: [21, 26]
};

export const Bone: Work = {
    title: {
        "es": "Hueso",
        "en": "Bone",
        "ja": "骨"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/bone.jpg",

    description: {
        "en": "",
    },
        
    isBuyable: false,
    price: "400 MXN",
    link: "/projects/project1",
    dimensions: [20, 26]
};


export const Hearth: Work = {
    title: {
        "es": "Corazón",
        "en": "Hearth",
        "ja": "心臓"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/hearth.jpg",

    description: {
        "en": "",
    },
        
    isBuyable: false,
    price: "400 MXN",
    link: "/projects/project1",
    dimensions: [25, 21]
};

export const Cempasutchil: Work = {
    title: {
        "es": "Cempasúchil",
        "en": "Cempasúchil",
        "ja": "センジュギク"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/hearth.jpg",

    description: {
        "en": "",
    },
        
    isBuyable: false,
    link: "/projects/project1",
    dimensions: [11, 11]
};

export const Ghost: Work = {
    title: {
        "es": "Fantasma",
        "en": "Ghost",
        "ja": "ゴースト"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/ghost.jpg",

    description: {
        "en": "",
    },
        
    isBuyable: false,
    price: "400 MXN",
    link: "/projects/project1",
    dimensions: [25, 22]
};

export const Star: Work = {
    title: {
        "es": "Estrella",
        "en": "Star",
        "ja": "星"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/star.jpg",

    description: {
        "en": "",
    },
        
    isBuyable: false,
    price: "400 MXN",
    link: "/projects/project1",
    dimensions: [11, 11]
};

export const ColdCoffee: Work = {
    title: {
        "es": "Café frío",
        "en": "Cold coffee",
        "ja": "冷たいコーヒー"
    },
    year: 2025,
    imageUrl: "/img/art/coldcoffee.jpg",

    description: {
        "en": "",
    },
    technique: InkOnPaper,        
    isBuyable: false,
    price: "400 MXN",
    sold: true,
    link: "/projects/project1",
    dimensions: [11, 11]
};
export const Altar: Work = {
    title: {
        "es": "Altar",
        "en": "Altar",
        "ja": "祭壇"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/altar.jpg",

    description: {
        "en": "",
    },
        
    isBuyable: false,
    price: "400 MXN",
    sold: true,
    link: "/projects/project1",
    dimensions: [11, 11]
};


export const PanDeMuerto25Color: Work =  {
    title: {
        "es": "Pan de muerto",
        "en": "Pan de muerto",
        "ja": "Pan de muerto"
    },
    technique: DigitalColor,
    year: 2025,
    imageUrl: "/img/art/pan_de_muerto.jpg",
    previewUrl: "/img/art/pan_de_muerto_low.jpg",

    description: {
        "en": ""
    },
        
    isBuyable: false,
    price: "400 MXN",
    link: "/projects/project1",
    dimensions: [2859, 2859],
    dimensionsUnit: "px"
};


export const PanDeMuerto25BW: Work =  {
    title: {
        "es": "Pan de muerto",
        "en": "Pan de muerto",
        "ja": "Pan de muerto"
    },
    year: 2025,
    imageUrl: "/img/art/panmuertobw.jpg",

    description: {
        "en": ""
    },
    technique: InkOnPaper,        
    isBuyable: false,
    price: "400 MXN",
    link: "/projects/project1",
    dimensions: [13, 18]
};

export const Snek: Work =  {
    title: {
        "es": "Serpiente",
        "en": "Snake",
        "ja": "蛇"
    },
    year: 2025,
    imageUrl: "/img/art/snek.jpg",

    description: {
        "en": ""
    },
    technique: InkOnPaper,
        
    isBuyable: false,
    price: "400 MXN",
    link: "/projects/project1",
    dimensions: [11, 11]
};

export const Shadow: Work =  {
    title: {
        "es": "Sombra",
        "en": "Shade",
        "ja": "影"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/shade.jpg",

    description: {
        "en": ""
    },
        
    isBuyable: false,
    price: "500 MXN",
    link: "/projects/project1",
    dimensions: [21, 20]
};



export const Plant: Work =  {
    title: {
        "es": "Planta",
        "en": "Plant",
        "ja": "植物"
    },
    year: 2025,
    imageUrl: "/img/art/plant.jpg",

    description: {
        "en": ""
    },
    technique: InkOnPaper,
        
    isBuyable: false,
    price: "500 MXN",
    link: "/projects/project1",
    dimensions: [30, 22]
};

export const Eye: Work =  {
    title: {
        "es": "Ojo",
        "en": "Eye",
        "ja": "目"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/eye.jpg",

    description: {
        "en": ""
    },
        
    isBuyable: false,
    price: "500 MXN",
    link: "/projects/project1",
    dimensions: [30, 22]
};

export const Butterfly: Work =  {
    title: {
        "es": "Mariposa",
        "en": "Butterfly",
        "ja": "蝶"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/eye.jpg",

    description: {
        "en": ""
    },
        
    isBuyable: false,
    price: "500 MXN",
    link: "/projects/project1",
    dimensions: [11, 11]
};

export const Clock: Work =  {
    title: {
        "es": "Reloj",
        "en": "Clock",
        "ja": "時計"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/clock.jpg",

    description: {
        "en": ""
    },
        
    isBuyable: false,
    price: "500 MXN",
    link: "/projects/project1",
    dimensions: [11, 11]
};



//#endregion

//#region mini 2026

export const ScaryPumpkin: Work =  {
    title: {
        "es": "Calabaza tenebrosa",
        "en": "Scary pumpkin",
        "ja": "怖いカボチャ"
    },
    technique: InkOnPaper,
    year: 2025,
    imageUrl: "/img/art/scary_pumpkin.jpg",
    previewUrl: "/img/art/scary_pumpkin_low.jpg",

    description: {
        "en": ""
    },
        
    isBuyable: false,
    price: "600 MXN",
    link: "/projects/project1",
    dimensions: [11, 11]
};

export const TimeWeight: Work =  {
    title: {
        "es": "El tiempo pasado pesa",
        "en": "Elapsed time is heavy",
        "ja": "時過重在"
    },
    technique: InkOnPaper,
    year: 2026,
    imageUrl: "/img/art/time_weight.jpg",
    previewUrl: "/img/art/time_weight.jpg",

    description: {
        "en": "The elapsed time is filled of heavy regrets and missed time.",
        "es": "El tiempo pasado esta lleno de pesados arrepentimientos y tiempo perdido.",
        "ja": "過去は重い後悔と失った時間で満ちています。",
    },
        
    isBuyable: false,
    price: "600 MXN",
    link: "/projects/project1",
    dimensions: [28, 21]
}

//#endregion

export const modifyWork = (base: Work, changes: Partial<Work>): Work => {
    return {
        ...base,
        ...changes
    }
};
